import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AptButtonModule, AptMaintenanceModule, AptTemplatesModule } from '@archinsurance-da/arch-portal-tools';

import { LoaderComponent } from './loader/loader.component';
import { AccessDeniedComponent } from './acccess-denied/access-denied.component';
import { TranslateModule } from '@ngx-translate/core';
import { ContentService } from '@shared/services/contentserver.service';
import { MaintenanceComponent } from './maintenance/maintenance.component';

@NgModule({
  imports: [CommonModule, AptTemplatesModule, AptButtonModule, AptMaintenanceModule, TranslateModule],
  declarations: [LoaderComponent, AccessDeniedComponent, MaintenanceComponent],
  exports: [LoaderComponent, AccessDeniedComponent, MaintenanceComponent],
  providers: [ContentService],
})
export class SharedModule {}
